export default "__VITE_ASSET__39f58dac__"